import { gql } from '@apollo/client'

import { TaskFragment, ActivityFragment, CommentFragment } from '../fragments'

export const TASK = gql`
  query task($id: ID!) {
    task(id: $id) {
      ...TaskFragment
    }
  }
  ${TaskFragment}
`

export const TASK_WITH_COMMENTS_AND_ACTIVITIES = gql`
  query taskWithCommentsAndActivities($id: ID!) {
    task(id: $id) {
      ...TaskFragment
      activities {
        ...ActivityFragment
      }
      comments {
        ...CommentFragment
      }
    }
  }
  ${TaskFragment}
  ${ActivityFragment}
  ${CommentFragment}
`
